import { FormattedMessage } from 'react-intl';
import { ReactElement, useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

import { PoolButton } from '../buttons';
import { PoolModal } from './pool-modal';
import { PoolModalActions } from './components/pool-modal-actions';
import { PoolModalContent } from './components/pool-modal-content';
import { PoolModalTitle } from './components/pool-modal-title';

interface PoolDiscardChangesModalProps {
    isDirty: boolean;
}

export const PoolDiscardChangesModal = ({ isDirty }: PoolDiscardChangesModalProps): ReactElement => {
    const [openDiscardChangesModal, setOpenDiscardChangesModal] = useState(false);

    const blocker = useBlocker(() => isDirty);

    useEffect((): void => {
        if (blocker.state === 'blocked') {
            setOpenDiscardChangesModal(true);
        }
    }, [blocker.state, blocker.location]);

    const handleConfirmDiscard = (): void => {
        setOpenDiscardChangesModal(false);
        blocker?.proceed?.();
    };

    const handleCancel = (): void => {
        setOpenDiscardChangesModal(false);
        blocker?.reset?.();
    };

    return (
        <PoolModal open={openDiscardChangesModal} maxWidth="sm">
            <PoolModalTitle>
                <FormattedMessage id="app.common.discardChanges.title" />
            </PoolModalTitle>
            <PoolModalContent>
                <FormattedMessage id="app.common.discardChanges.text" />
            </PoolModalContent>
            <PoolModalActions sx={{ flexDirection: 'row' }}>
                <PoolButton variant="outlined" onClick={handleCancel} autoFocus>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>
                <PoolButton color={'primary'} onClick={handleConfirmDiscard} data-testid="confirm">
                    <FormattedMessage id="app.common.discardChanges.title" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
